import { loadState, saveState } from '..';

export default (localStorageKey) => {
    const state = loadState(localStorageKey) ?? [];

    const add = (key, value) => {
        const filteredState = state.filter(item => item.token !== key);
        const newState = [value, ...filteredState];

        saveState(localStorageKey, newState);
    };

    const remove = (key) => {
        const newState = [...state];
        const indexToDelete = newState.findIndex(item => item.id === key);

        if (indexToDelete !== -1) {
            newState.splice(indexToDelete, 1);
        }

        saveState(localStorageKey, newState);

        return newState;
    };

    const clear = () => {
        saveState(localStorageKey, []);
    };

    const override = (newState) => {
        saveState(localStorageKey, newState);
    };

    return {
        add, remove, clear, override
    };
};
